export default __webpack_public_path__ + "static/char-04-35966621145ab994f71bb6452b5339d8.gif";